export const PURPLE = '#60313d';
export const ORANGE = '#f37d68';
export const PINK = '#efd0dd';
export const LIGHT_PURPLE = '#774e55';